import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApplicationId } from '@nx-customer-apps/components';
import { API_PLANNING_PROJECTS_CONFIG, ApiPlanningProjectsConfig } from '../api-plannig-projects.config';
import { ConfigurationFields, Endpoints } from '../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoomByRoomApiService {
    private readonly baseUrl: string;
    private readonly applicationId: ApplicationId = ApplicationId.ViGuidePlanning;

    constructor(
        @Inject(API_PLANNING_PROJECTS_CONFIG) config: ApiPlanningProjectsConfig,
        private httpClient: HttpClient
    ) {
        this.baseUrl = config.apiBaseUrl;
        this.applicationId = config.applicationId;
    }

    public getConfiguration$(params: { fields: ConfigurationFields[] }): Observable<any> {
        const url = `${this.baseUrl}${Endpoints.Configurations}`;
        return this.httpClient.get(url, { params });
    }
}
